import { render, staticRenderFns } from "./FormContent.vue?vue&type=template&id=165c450e&scoped=true&"
import script from "./FormContent.vue?vue&type=script&lang=js&"
export * from "./FormContent.vue?vue&type=script&lang=js&"
import style0 from "../../../less/form.less?vue&type=style&index=0&id=165c450e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c450e",
  null
  
)

export default component.exports